// ─── User Roles ───────────────────────────────────────────────────────────────
export const ROLES = {
  CUSTOMER: 'customer',
  WORKER:   'worker',
  ADMIN:    'admin',
}

// ─── Booking Statuses ─────────────────────────────────────────────────────────
export const BOOKING_STATUS = {
  PENDING:          'pending',
  QUOTED:           'quoted',
  CONFIRMED:        'confirmed',
  ASSIGNED:         'assigned',
  EN_ROUTE:         'en_route',
  IN_PROGRESS:      'in_progress',
  PENDING_APPROVAL: 'pending_approval',
  COMPLETED:        'completed',
  CANCELLED:        'cancelled',
  DISPUTED:         'disputed',
}

export const BOOKING_STATUS_LABELS = {
  pending:          'Pending',
  quoted:           'Quote Ready',
  confirmed:        'Confirmed',
  assigned:         'Worker Assigned',
  en_route:         'On the Way',
  in_progress:      'In Progress',
  pending_approval: 'Awaiting Approval',
  completed:        'Completed',
  cancelled:        'Cancelled',
  disputed:         'Disputed',
}

// ─── Payment Statuses ─────────────────────────────────────────────────────────
export const PAYMENT_STATUS = {
  UNPAID:   'unpaid',
  PAID:     'paid',
  HELD:     'held',
  RELEASED: 'released',
  REFUNDED: 'refunded',
}

// ─── Urgency Types ────────────────────────────────────────────────────────────
export const URGENCY = {
  SCHEDULED: 'scheduled',
  URGENT:    'urgent',
}

// ─── Service Trades ───────────────────────────────────────────────────────────
export const TRADES = {
  PLUMBING:    'plumbing',
  ELECTRICAL:  'electrical',
  AIRCON:      'aircon',
  CARPENTRY:   'carpentry',
  PAINTING:    'painting',
  MASONRY:     'masonry',
}

export const TRADE_LABELS = {
  plumbing:   'Tubero / Plumbing',
  electrical: 'Electrical',
  aircon:     'Aircon',
  carpentry:  'Carpentry',
  painting:   'Painting',
  masonry:    'Masonry',
}

// ─── Photo Types ──────────────────────────────────────────────────────────────
export const PHOTO_TYPE = {
  CUSTOMER_SUBMITTED: 'customer_submitted',
  BEFORE:             'before',
  DURING:             'during',
  AFTER:              'after',
  MATERIALS_RECEIPT:  'materials_receipt',
  ADDITIONAL_FINDING: 'additional_finding',
}

// ─── Supabase Storage Buckets ─────────────────────────────────────────────────
export const STORAGE_BUCKETS = {
  BOOKING_PHOTOS: 'booking-photos',
  RECEIPTS:       'receipts',
  WORKER_DOCS:    'worker-docs',
  AVATARS:        'avatars',
}

// ─── Platform Commission ──────────────────────────────────────────────────────
export const PLATFORM_COMMISSION_RATE = 0.15   // 15%
export const URGENT_MULTIPLIER         = 1.30   // 30% surcharge

// ─── Auth Providers ───────────────────────────────────────────────────────────
export const AUTH_PROVIDER = {
  GOOGLE: 'google',
  PHONE:  'phone',
}

// ─── Philippine Phone Prefix ──────────────────────────────────────────────────
export const PH_PHONE_PREFIX = '+63'

// ─── OTP Config ───────────────────────────────────────────────────────────────
export const OTP_LENGTH         = 6
export const OTP_RESEND_SECONDS = 60

// ─── Warranty Period ──────────────────────────────────────────────────────────
export const WARRANTY_DAYS = 30

// ─── App Meta ─────────────────────────────────────────────────────────────────
export const APP_NAME     = 'Siglat Konstract'
export const APP_TAGLINE  = 'Book trusted construction workers in minutes'
export const APP_CURRENCY = 'PHP'
export const APP_CURRENCY_SYMBOL = '₱'
